import React from 'react';
import Room from "./Room";
import {useSelector} from "react-redux";

const SelectRoom = () => {
    const rooms = useSelector(state => state.rooms);
    function sortPrice(a, b) {
        if (parseFloat(a['price']['pretax']) < parseFloat(b['price']['pretax']))
            return -1;
        if (parseFloat(a['price']['pretax']) > parseFloat(b['price']['pretax']))
            return 1;
        return 0;
    }
    return (
        <div>
            {rooms.length > 0 && rooms.sort(sortPrice).filter((room)=>room['price']['pretax']>0).map((room) => <Room key={room.index} roomData={room}/>)}
        </div>
    );
};

export default SelectRoom;
